import React from 'react';
import PropTypes from 'prop-types';
import { StyledSpinnerWrapper, StyledSpinnerSvg } from './styles';

const SPINNER_SIZE = 28;
const STROKE_WIDTH = 3;
const RADIUS = (SPINNER_SIZE - STROKE_WIDTH) / 2;
const CENTER = SPINNER_SIZE / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;
const ARC_RATIO = 0.75;
const ARC_LENGTH = CIRCUMFERENCE * ARC_RATIO;

export const LoadingSpinner = ({ variant = 'dark', decorative = false }) => {
  return (
    <StyledSpinnerWrapper
      data-testid="loading-spinner"
      role={decorative ? undefined : 'status'}
      aria-label={decorative ? undefined : 'Loading'}
      aria-hidden={decorative || undefined}
    >
      <StyledSpinnerSvg
        $variant={variant}
        viewBox={`0 0 ${SPINNER_SIZE} ${SPINNER_SIZE}`}
        aria-hidden="true"
      >
        <circle
          className="track"
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill="none"
          strokeWidth={STROKE_WIDTH}
        />
        <circle
          className="arc"
          cx={CENTER}
          cy={CENTER}
          r={RADIUS}
          fill="none"
          strokeWidth={STROKE_WIDTH}
          strokeDasharray={`${ARC_LENGTH} ${CIRCUMFERENCE}`}
          strokeLinecap="round"
          transform={`rotate(-90 ${CENTER} ${CENTER})`}
        />
      </StyledSpinnerSvg>
    </StyledSpinnerWrapper>
  );
};

LoadingSpinner.displayName = 'LoadingSpinner';

LoadingSpinner.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark']),
  decorative: PropTypes.bool,
};
